import './App.css';
import React, { useState, } from 'react';
import Clock from './components/Clock'
import Notes from './components/Notes';
import Weather from './components/Weather';
import Calender from "../src/components/Calender"
import Pokemon from './components/pokemon';
import Navbar from './components/common/navbar';
import Card from './components/common/Card';
function App() {

  return (
    <>
      <Navbar />

      <main className='bg-backgroundColor'>
        <div className='container'>
          <Clock></Clock>
          <Notes />
        </div>
        <div className='container'>
          <Weather />

          <div className='container lg:grid grid-cols-2'>
            <Calender />
            <Pokemon />
          </div>

        </div>
      </main>
    </>
  );
}

export default App;
